import React from 'react';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
//Librerias externas
import { Button, Card, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { withToastManager } from 'react-toast-notifications';
import { cols } from '../../views/SaleReport/colsDataExcel';
//Componentes internos
import apiClient from '../../services/APIClient';
import FormInputField from '../FormInputField';
import FormSelectField from '../FormSelectField';
import Loading from '../Loading';
import { BarChart } from './BarChart';

class Reporte extends React.Component {
  static propTypes = {
    toastManager: PropTypes.object.isRequired,
  };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      fromDay: '',
      toDay: '',
      dataSelect: [],
      idSelect: [],
      verticalValues: [''],
      horizontalValues: [''],
      entity: this.props.entity,
      title: [''],
      //excel
      cols: cols,
      title: '',
      disabled: true
    };
    this.loadCargaSelect = this.loadCargaSelect.bind(this);
  }
  componentDidMount() {
    this.loadCargaSelect();
  }
  //Load de carga selec
  loadCargaSelect = async () => {
    const { entity } = this.state;
    const url = `${
      entity === 'General'
        ? 'entregas?&excludeAssocFields=detalles'
        : entity === 'Clientes'
        ? 'clientes?&sortField=razonSocial&sortDir=asc'
        : entity.toLowerCase()
    }`;
    const dataSelectRes = await apiClient.get(`/${url}`);
    this.setState({
      ...this.state,
      dataSelect: dataSelectRes.data.data,
      isLoading: false,
    });
  };
  //Captura Fecha
  handleDataChange = (e) => {
    const { id, value } = e.target;

    this.setState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  //Captura Select de busqueda
  handleSubmit = (e) => {
    const { value, options } = e.target;
    const opcionSelect = [...options].filter((opt) => opt.selected).map((opt) => opt.textContent);
    {
      opcionSelect == '(Seleccione)'
        ? this.setState({
            idSelect: value,
            title: opcionSelect,
            disabled: true,
          })
        : this.setState({
            idSelect: value,
            title: opcionSelect,
            disabled: false,
          });
    }
  };

  //get excel
  getExportData = async () => {
    const { toastManager } = this.props;
    const { fromDay, toDay, entity, idSelect } = this.state;
    try {
      const fromDate = moment(fromDay).format('YYYY/MM/DD HH:mm');
      const toDate = moment(toDay).format('YYYY/MM/DD HH:mm');
      const dateFilters = `fromDate=${fromDate}&toDate=${toDate}`;
      const searchImputValueID = `id=${idSelect}`;
      const queryEntity = `entity=${entity}`;
      const getDataScv = `getDataScv=${true}`;
      const queryParams = `${dateFilters}&${searchImputValueID}&${queryEntity}&${getDataScv}`;
      const apiResponse = await apiClient.get(`/sale-report/sell-out?${queryParams}`);
      return apiResponse.data.data;
    } catch (error) {
      toastManager.add(`Ocurrió un error: "${error.message}"`, {
        appearance: 'error',
      });
      return false;
    }
  };
  
  //Envio de datos por GET
  handleDataChangaSubmit = async () => {
    const { fromDay, toDay, entity, idSelect } = this.state;
    const { toastManager } = this.props;
    if (fromDay > toDay) {
      const toastMessage = `La fecha final no puede ser menor a la fecha de inicio`;
      toastManager.add(toastMessage, {
        appearance: 'warning',
        autoDismiss: false,
      });
    } else if (entity !== 'General' && idSelect == '') {
      const toastMessage = `Debes seleccionar ${entity}`;
      toastManager.add(toastMessage, {
        appearance: 'warning',
        autoDismiss: false,
      });
    } else if (fromDay === '' || toDay === '') {
      const toastMessage = `Ingresa un rango de fecha `;
      toastManager.add(toastMessage, {
        appearance: 'warning',
        autoDismiss: false,
      });
    } else {
      // parse month values into full dates.
      const fromDate = moment(fromDay).format('YYYY/MM/DD HH:mm');
      const toDate = moment(toDay).format('YYYY/MM/DD HH:mm');
      const dateFilters = `fromDate=${fromDate}&toDate=${toDate}`;
      const searchImputValueID = `id=${idSelect}`;
      const queryEntity = `entity=${entity}`;
      const queryParams = `${dateFilters}&${searchImputValueID}&${queryEntity}`;
      const dataSelectRes = await apiClient.get(`/sale-report?${queryParams}`);

      const isBilled = !dataSelectRes.data.data.arrayDataChartX.every((elem) => elem === '0.00');
      if (!isBilled) {
        const toastMessage = `al parecer no hay entregas facturadas para este reporte ${entity} en el rango de fecha especificado`;
        toastManager.add(toastMessage, {
          appearance: 'warning',
          autoDismiss: false,
        });
      }

      this.setState({
        verticalValues: dataSelectRes.data.data.arrayDataChartY,
        horizontalValues: dataSelectRes.data.data.arrayDataChartX,
      });
    }
  };

  shouldComponentUpdate(prevProps, prevtState) {

    const { toDay, fromDay, title } = this.state;
    const { toDay: prevToDay, fromDay: prevFromDay, title: prevTitle } = prevtState;

    if (prevToDay != toDay || prevFromDay != fromDay || prevTitle != title) {
      return false;
    } else {
      return true;
    }
  }
  render() {
    const { toDay, fromDay, disabled, dataSelect, title, entity, verticalValues, horizontalValues, cols, isLoading } = this.state;
    return (
      <div>
        <Card.Body>
          <Row className="d-flex align-items-center">
            <Col md={3}>
              <FormInputField
                id="fromDay"
                type="date"
                label="Fecha desde:"
                value={fromDay !== '' ? fromDay : null}
                onChange={this.handleDataChange}
                required
              />
            </Col>
            <Col md={3}>
              <FormInputField
                id="toDay"
                type="date"
                label="Fecha hasta:"
                onChange={this.handleDataChange}
                value={toDay !== '' ? toDay : null}
                min={fromDay !== '' ? fromDay : null}
                required
              />
            </Col>
            {entity === 'General' ? (
              <div></div>
            ) : (
              <Fragment>
                <Col className="d-flex justify-content-end" md={5}>
                  {entity === 'Clientes' && (
                    <FormSelectField
                      id="clientes"
                      label={entity}
                      type="text"
                      choices={dataSelect}
                      choiceIdField="id"
                      choiceLabelField="razonSocial"
                      onChange={this.handleSubmit}
                      custom
                    />
                  )}
                  {entity === 'Articulos' && (
                    <FormSelectField
                      id="articulos"
                      label={entity}
                      type="text"
                      choices={dataSelect}
                      choiceIdField="id"
                      choiceLabelField="descripcion"
                      onChange={this.handleSubmit}
                      custom
                    />
                  )}
                  {entity === 'Lineas' && (
                    <FormSelectField
                      id="lineas"
                      label={entity}
                      type="text"
                      choices={dataSelect}
                      choiceIdField="id"
                      choiceLabelField="descripcion"
                      onChange={this.handleSubmit}
                      custom
                    />
                  )}
                  {entity === 'Provincias' && (
                    <FormSelectField
                      id="provincias"
                      label={entity}
                      type="text"
                      choices={dataSelect}
                      choiceIdField="codigo"
                      choiceLabelField="descripcion"
                      onChange={this.handleSubmit}
                      custom
                    />
                  )}
                </Col>
              </Fragment>
            )}
            <div style={{ 'margin-top': '0.8rem' }}>
              <Button variant="primary" size="md" onClick={this.handleDataChangaSubmit}>
                Buscar
              </Button>
            </div>
          </Row>
        </Card.Body>

        {isLoading == true ? (
          <Loading />
        ) : (
          <div>
            <BarChart title={title} entity={entity} verticalValues={verticalValues} horizontalValues={horizontalValues} />
          </div>
        )}
      </div>
    );
  }
}
export default withToastManager(Reporte);
